export default __webpack_public_path__ + "static/media/discord.e8ba579a.svg";